function scrollSelectedSwatchIntoView() {
  try {
    document.querySelectorAll('fieldset.product-form__input').forEach((fieldset) => {
      // Try both input types
      const checked = fieldset.querySelector('.swatch-input__input:checked, .button-input__input:checked');
      if (!checked) return;
  
      const label = fieldset.querySelector(`label[for="${checked.id}"]`);
      if (!label) return;
  
      // Find the actual scroll container — could be the fieldset or a child wrapper
      const scrollEl = Array.from(fieldset.querySelectorAll('*')).find(el => {
        const style = getComputedStyle(el);
        return (style.overflowX === 'auto' || style.overflowX === 'scroll') && el.scrollWidth > el.clientWidth;
      }) || fieldset;
  
      const labelLeft = label.offsetLeft;
      const labelWidth = label.offsetWidth;
      const containerWidth = scrollEl.clientWidth;
      const scrollTarget = labelLeft - (containerWidth / 2) + (labelWidth / 2);
  
      scrollEl.scrollTo({ left: scrollTarget, behavior: 'smooth' });
    });
  }
  catch (e) {}
}

function updatePackPricing() {
  try {
    const variantDataEl = document.getElementById('product-variants-json');
    if (!variantDataEl) return;
  
    const variants = JSON.parse(variantDataEl.textContent);
  
    document.querySelectorAll('.quantity-swatch-discounted-price[data-name]').forEach((el) => {
      const name = el.dataset.name;
      const match = name.match(/^(\d+)-[Pp]ack$/);
      if (!match) return;
  
      const itemCount = parseInt(match[1], 10);
  
      const variant = variants.find((v) => v.options.some((o) => o.toLowerCase() === name.toLowerCase()));
      if (!variant) return;
  
      const price = variant.price / 100;
      const compareAtPrice = variant.compare_at_price ? variant.compare_at_price / 100 : null;
  
      const perItem = Math.floor((price / itemCount) * 100) / 100;
      const comparePerItem = compareAtPrice ? (compareAtPrice / itemCount).toFixed(2) : null;
  
      // el.innerHTML = `
      // ${comparePerItem ? `<s class="price-per-item--compare">$${comparePerItem} /Item</s>` : ''}
      // <span class="price-per-item">$${perItem} /Item</span>
      // `;
      el.innerHTML = `
      <span class="price-per-item">$${perItem} /Item</span>
      `;
    });
  }
  catch (e) {}
}

function handleCurrencyChanges(country, elements) {
  try {
    let prefix = "";
    if (country === "CANADA") {
      prefix = "CA";
    } else if (country === "AUSTRALIA") {
      prefix = "AU";
    } else if (country === "NEW ZEALAND") {
      prefix = "NZ";
    } else if (country === "PAKISTAN") {
      prefix = "PK";
    } else if (country === "SINGAPORE") {
      prefix = "SG";
    } else if (country === "HONG KONG") {
      prefix = "HK";
    }
    for (let i = 0; i < elements.length; i++) {
      if (!elements[i].innerText.includes(prefix)) {
        elements[i].innerText = prefix + elements[i].innerText;
      }
    }
  } 
  catch (e) {}
}

function handleCountryLogic() {
  try {
    // Country Logic
    const pricePrefixes = document.getElementsByClassName(
      "price__prefix"
    );
    const itemsToProcess = [...pricePrefixes];
    if (itemsToProcess && itemsToProcess.length > 0) {
      fetch("https://robify.ezapp.ovh/country?justcountry=1")
        .then((response) => response.text())
        .then((country) => {
          try {
            let countryProcessed = country.split(", ");
            countryProcessed = countryProcessed[0].split(" (")[0];

            if (pricePrefixes.length > 0) {
              handleCurrencyChanges(countryProcessed, pricePrefixes);
            }
          } catch (e) {
            console.error("Unable to handle custom country logic:", e);
          }
        });
    }
  }
  catch (e) {}
}

const highGiftId = 57037992460670;
const lowGiftId = 57038047084926;
const highGiftName = 'Free Gift';
const lowGiftName = 'Free E-Book';
const freeShippingThresholdUSD = 50;

// Single source of truth - fetch cart once and pass to all functions
function syncCart() {
  fetch(theme.routes.cart_url + '.js')
    .then((res) => res.json())
    .then((cart) => {
      handleBonusVariantSync(cart);
      updateFreeGiftsMessage(cart);
      initFreeGiftRemovalButtons(cart);
    })
    .catch((e) => console.error('Failed to fetch cart:', e));
}

function handleBonusVariantSync(cart) {
  try {
    const items = cart.items;

    const highGiftRemoved = sessionStorage.getItem('highGiftRemoved') === 'true';
    const lowGiftRemoved = sessionStorage.getItem('lowGiftRemoved') === 'true';

    const fifteenPackCount = items
      .filter(item => item.variant_title?.includes('15-Pack') && item.variant_id !== highGiftId)
      .reduce((sum, item) => sum + item.quantity, 0);

    const tenPackExists = items.some(
      item => item.variant_title?.includes('10-Pack') && item.variant_id !== lowGiftId
    );

    const currentFifteenBonus = items.find(item => item.variant_id === highGiftId);
    const currentTenBonus = items.find(item => item.variant_id === lowGiftId);

    const updates = {};

    if (!highGiftRemoved && (currentFifteenBonus?.quantity ?? 0) !== fifteenPackCount) {
      updates[highGiftId] = fifteenPackCount;
    }

    const desiredTenBonus = tenPackExists ? 1 : 0;
    if (!lowGiftRemoved && (currentTenBonus?.quantity ?? 0) !== desiredTenBonus) {
      updates[lowGiftId] = desiredTenBonus;
    }

    if (Object.keys(updates).length === 0) return;

    const sectionsToRender = document.querySelector('cart-items')?.getSectionsToRender()
      .filter(s => s.section)
      .map(s => s.section) || [];

    fetch(theme.routes.cart_url + '/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        updates,
        sections: sectionsToRender,
        sections_url: window.location.pathname
      })
    })
      .then((res) => res.json())
      .then((updatedCart) => {
        console.log('Bonus variants synced:', updatedCart);
        document.dispatchEvent(new CustomEvent('cart:refreshDrawer', {
          detail: { parsedState: updatedCart }
        }));
        updateFreeGiftsMessage(updatedCart);
      })
      .catch((e) => console.error('Failed to sync bonus variants:', e));
  } catch (e) {}
}

function initFreeGiftRemovalButtons(cart) {
  [highGiftId, lowGiftId].forEach((variantId) => {
    const btn = document.getElementById(`free-gift-removal-${variantId}`);
    if (!btn || btn.dataset.initialized) return;

    btn.dataset.initialized = 'true';
    btn.addEventListener('click', (e) => {
      e.preventDefault();

      const isHighGift = variantId === highGiftId;
      const cacheKey = isHighGift ? 'highGiftRemoved' : 'lowGiftRemoved';
      sessionStorage.setItem(cacheKey, 'true');

      const sectionsToRender = document.querySelector('cart-items')
        ?.getSectionsToRender()
        .filter(s => s.section)
        .map(s => s.section) || [];

      fetch(theme.routes.cart_url + '/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          updates: { [variantId]: 0 },
          sections: sectionsToRender,
          sections_url: window.location.pathname
        })
      })
        .then((res) => res.json())
        .then((updatedCart) => {
          document.dispatchEvent(new CustomEvent('cart:refreshDrawer', {
            detail: { parsedState: updatedCart }
          }));
          updateFreeGiftsMessage(updatedCart);
        })
        .catch((e) => console.error('Failed to remove free gift:', e));
    });
  });
}

function updateFreeGiftsMessage(cart) {
  const messageEl = document.querySelector('.free-gifts-message');
  if (!messageEl) return;

  const items = cart.items;

  const highGiftRemoved = sessionStorage.getItem('highGiftRemoved') === 'true';
  const lowGiftRemoved = sessionStorage.getItem('lowGiftRemoved') === 'true';

  const fifteenPackCount = items
    .filter(item => item.variant_title?.includes('15-Pack') && item.variant_id !== highGiftId)
    .reduce((sum, item) => sum + item.quantity, 0);

  const tenPackExists = items.some(
    item => item.variant_title?.includes('10-Pack') && item.variant_id !== lowGiftId
  );

  const hasHighGiftInCart = items.some(item => item.variant_id === highGiftId);
  const hasLowGiftInCart = items.some(item => item.variant_id === lowGiftId);

  // Free shipping calculation
  const currencyRate = parseFloat(Shopify.currency.rate) || 1;
  const thresholdInCurrentCurrency = freeShippingThresholdUSD * currencyRate;
  const cartTotal = cart.total_price / 100; // Shopify returns price in cents
  const hasShipping = cartTotal >= thresholdInCurrentCurrency;
  const amountLeft = (thresholdInCurrentCurrency - cartTotal).toFixed(2);

  // Gift unlock states
  const lowGiftFilled = tenPackExists;
  const highGiftFilled = fifteenPackCount > 0;

  // Progress: 0 = nothing, 1 = shipping, 2 = low gift, 3 = both gifts
  let fillWidth = '0';
  if (hasShipping && lowGiftFilled && highGiftFilled) fillWidth = '100';
  else if (lowGiftFilled && highGiftFilled) fillWidth = '66';
  else if (hasShipping && lowGiftFilled) fillWidth = '66';
  else if (hasShipping && highGiftFilled) fillWidth = '100'; // shipping + high gift, no low
  else if (highGiftFilled) fillWidth = '100';               // only high gift
  else if (hasShipping && !lowGiftFilled) fillWidth = '33';
  else if (lowGiftFilled) fillWidth = '33';
  else fillWidth = '0';

// Build base message
let message = '';
if (!hasShipping && !tenPackExists && fifteenPackCount === 0) {
  message = `<em><strong>You're ${Shopify.currency.active} ${amountLeft} away from Free Shipping!</strong></em>`;
} else if (hasShipping && !tenPackExists && fifteenPackCount === 0) {
  message = `🎉 Congratulations!<br><br>Free Shipping - <strong>Unlocked</strong><br><br><em><strong>Add a 10-Pack and unlock a ${lowGiftName}!</strong></em>`;
} else if (!hasShipping && tenPackExists && fifteenPackCount === 0) {
  message = `🎉 Congratulations!<br><br>${lowGiftName} - <strong>Unlocked</strong><br><br>You're ${Shopify.currency.active} ${amountLeft} away from Free Shipping.<br><em><strong>Add a 15-Pack and unlock a ${highGiftName}!</strong></em>`;
} else if (hasShipping && tenPackExists && fifteenPackCount === 0) {
  message = `🎉 Congratulations!<br><br>Free Shipping - <strong>Unlocked</strong><br>${lowGiftName} - <strong>Unlocked</strong><br><br><em><strong>Add a 15-Pack and unlock a ${highGiftName}!</strong></em>`;
} else if (!hasShipping && !tenPackExists && fifteenPackCount > 0) {
  message = fifteenPackCount === 1
    ? `🎉 Congratulations!<br><br>${highGiftName} - <strong>Unlocked</strong><br><br>You're ${Shopify.currency.active} ${amountLeft} away from Free Shipping.<br><em><strong>Add a 10-Pack and unlock a ${lowGiftName}!</strong></em>`
    : `🎉 Congratulations!<br><br>${highGiftName}s (×${fifteenPackCount}) - <strong>Unlocked</strong><br><br>You're ${Shopify.currency.active} ${amountLeft} away from Free Shipping.<br><em><strong>Add a 10-Pack and unlock a ${lowGiftName}!</strong></em>`;
} else if (hasShipping && !tenPackExists && fifteenPackCount > 0) {
  message = fifteenPackCount === 1
    ? `🎉 Congratulations!<br><br>Free Shipping - <strong>Unlocked</strong><br>${highGiftName} - <strong>Unlocked</strong><br><br><em><strong>Add a 10-Pack and unlock a ${lowGiftName}!</strong></em>`
    : `🎉 Congratulations!<br><br>Free Shipping - <strong>Unlocked</strong><br>${highGiftName}s (×${fifteenPackCount}) - <strong>Unlocked</strong><br><br><em><strong>Add a 10-Pack and unlock a ${lowGiftName}!</strong></em>`;
} else if (!hasShipping && tenPackExists && fifteenPackCount > 0) {
  message = fifteenPackCount === 1
    ? `🎉 Congratulations!<br><br>${lowGiftName} - <strong>Unlocked</strong><br>${highGiftName} - <strong>Unlocked</strong><br><br>You're ${Shopify.currency.active} ${amountLeft} away from Free Shipping!`
    : `🎉 Congratulations!<br><br>${lowGiftName} - <strong>Unlocked</strong><br>${highGiftName}s (×${fifteenPackCount}) - <strong>Unlocked</strong><br><br>You're ${Shopify.currency.active} ${amountLeft} away from Free Shipping!`;
} else if (hasShipping && tenPackExists && fifteenPackCount > 0) {
  message = fifteenPackCount === 1
    ? `🎉 Congratulations!<br><br>Free Shipping - <strong>Unlocked</strong><br>${lowGiftName} - <strong>Unlocked</strong><br>${highGiftName} - <strong>Unlocked</strong>`
    : `🎉 Congratulations!<br><br>Free Shipping - <strong>Unlocked</strong><br>${lowGiftName} - <strong>Unlocked</strong><br>${highGiftName}s (×${fifteenPackCount}) - <strong>Unlocked</strong>`;
}
  
  // Build removed messages
  const removedParts = [];

  if (lowGiftRemoved && !hasLowGiftInCart) {
    removedParts.push(`You have removed your ${lowGiftName}. <a href="#" class="free-gift-readd" data-gift="low">Click here</a> to add it again.`);
  }

  if (highGiftRemoved && !hasHighGiftInCart) {
    const giftWord = fifteenPackCount > 1 ? `${highGiftName}s` : highGiftName;
    const themWord = fifteenPackCount > 1 ? 'them' : 'it';
    removedParts.push(`You have removed your ${giftWord}. <a href="#" class="free-gift-readd" data-gift="high">Click here</a> to add ${themWord} again.`);
  }

  const fullMessage = [message, ...removedParts].filter(Boolean).join('<br><br>');

  messageEl.innerHTML = `
    <p class="free-gifts-progress__message">${fullMessage}</p>
    <div class="free-gifts-progress">
      <div class="free-gifts-progress__track">
        <div class="free-gifts-progress__fill" style="width: ${fillWidth}%"></div>

        <div class="free-gifts-progress__marker free-gifts-progress__marker--shipping ${hasShipping ? 'is-filled' : ''}">
          <span class="free-gifts-progress__label">Free Shipping</span>
        </div>
        <div class="free-gifts-progress__marker free-gifts-progress__marker--low ${lowGiftFilled ? 'is-filled' : ''}">
          <span class="free-gifts-progress__label">${lowGiftName}</span>
        </div>
        <div class="free-gifts-progress__marker free-gifts-progress__marker--high ${highGiftFilled ? 'is-filled' : ''}">
          <span class="free-gifts-progress__label">${highGiftName}</span>
        </div>
      </div>
    </div>
  `;

  // Bind "Click here" links
  messageEl.querySelectorAll('.free-gift-readd').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const gift = link.dataset.gift;
      if (gift === 'low') sessionStorage.removeItem('lowGiftRemoved');
      if (gift === 'high') sessionStorage.removeItem('highGiftRemoved');
      syncCart();
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  updatePackPricing();
  scrollSelectedSwatchIntoView();

  subscribe(PUB_SUB_EVENTS.variantChange, () => {
    requestAnimationFrame(() => {
      updatePackPricing();
      scrollSelectedSwatchIntoView();
    });
  });

  handleCountryLogic();

  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (event?.source === 'bonus-variant-sync') return;
    syncCart();
  });

  syncCart();
});

document.addEventListener("cartdrawer:opened", function () {
  setTimeout(() => {
    handleCountryLogic();
    syncCart();
  }, 500);
  setTimeout(() => {
    handleCountryLogic();
    syncCart();
  }, 1000);
  setTimeout(() => {
    handleCountryLogic();
    syncCart();
  }, 1500);
});

document.addEventListener("cart:refreshDrawer", function () {
  handleCountryLogic();
  setTimeout(() => {
    syncCart();
  }, 500);
  setTimeout(() => {
    syncCart();
  }, 1000);
});